module.exports = __webpack_public_path__ + "static/logoSura-2a047f33786794699ef4a04393d065f0.svg";